export const dateFormat = 'yyyy-MM-dd';
export const momentDateFormat = `YYYY-MM-DD`;
export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;
export const momentDateTimeFormat = `${momentDateFormat} ${timeFormat}`;

export const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
